import {
  Badge,
  DeleteButton,
  EditButton,
  List,
  ShowButton,
  Space,
  Table,
  Tag,
  TextField,
  useTable,
} from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import { IPartnerUser } from "interfaces";
import { FC } from "react";

export const PartnerUsersList: FC<IResourceComponentsProps> = () => {
  const { tableProps } = useTable<IPartnerUser>({
    initialPageSize: 20,
    hasPagination: false,
  });

  return (
    <List
      title="Usuários Parceiros"
      createButtonProps={{ children: "Novo Parceiro", type: "primary" }}
    >
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="name"
          title="Nome"
          render={(value) => <TextField value={value || "-"} />}
        />

        <Table.Column
          dataIndex="username"
          title="Username"
          render={(value) => <TextField value={value || "-"} />}
        />

        <Table.Column
          dataIndex="partners"
          title="Parceiros"
          render={(partners: string[]) => (
            <Space wrap>
              {partners?.map((p) => (
                <Tag key={p}>{p}</Tag>
              ))}
            </Space>
          )}
        />

        <Table.Column
          dataIndex="status"
          title="Status"
          render={(value) => (
            <Badge
              status={value === "active" ? "success" : "default"}
              text={value === "active" ? "Ativo" : "Inativo"}
            />
          )}
        />

        <Table.Column
          dataIndex="created_at"
          title="Criado em"
          render={(value) =>
            value ? new Date(value).toLocaleDateString("pt-BR") : "-"
          }
        />

        <Table.Column
          title="Ações"
          render={(_, record: IPartnerUser) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <ShowButton hideText size="small" recordItemId={record.id} />
              <DeleteButton
                hideText
                size="small"
                recordItemId={record.id}
                confirmTitle="Tem certeza que deseja remover este usuário parceiro?"
              />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
